import { resolvePlanPrice } from './planAnnualPricing';

/** Preços SaaS da seção Aplicativos Mobile — valores numéricos por moeda e ciclo. */

export const MOBILE_APPS_PLAN_PRICES = {
  start: {
    monthly: { BRL: 1497, EUR: 249, USD: 299 },
    annual: { BRL: 14970, EUR: 2490, USD: 2990 }
  },
  growth: {
    monthly: { BRL: 2997, EUR: 499, USD: 599 },
    annual: { BRL: 29970, EUR: 4990, USD: 5990 }
  },
  premium: {
    monthly: { BRL: 5997, EUR: 999, USD: 1199 },
    annual: { BRL: 59970, EUR: 9990, USD: 11990 },
    plus: true
  }
};

export function getDefaultMobileAppsCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale) {
  if (!formatterCache.has(locale)) {
    formatterCache.set(
      locale,
      new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    );
  }
  return formatterCache.get(locale);
}

export function formatMobileAppsPlanPrice(amount, currency, cycle, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const isEn = language === 'en' || (language && !String(language).startsWith('pt'));
  const periodMonthly = isEn ? '/mo' : '/mês';
  const periodAnnual = isEn ? '/yr' : '/ano';
  const period = cycle === 'monthly' ? periodMonthly : periodAnnual;

  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${period}${suffix}`;
  if (currency === 'EUR') return `${n} €${period}${suffix}`;
  return `US$ ${n}${period}${suffix}`;
}

export function getMobileAppsPlanPrice(planKey, currency, cycle, language) {
  return resolvePlanPrice({
    plan: MOBILE_APPS_PLAN_PRICES[planKey],
    currency,
    cycle,
    language,
    formatPrice: formatMobileAppsPlanPrice
  });
}
